/**
 * CSK Demo Hub - launcher adapter.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import { HubDemoLauncher } from "@csk/demo-ui";
import { HUB_ROUTE_SLUGS } from "./route-table.js";

export function HubLauncher(): React.JSX.Element {
  return <HubDemoLauncher wiredSlugs={HUB_ROUTE_SLUGS} />;
}
